module.exports = __webpack_public_path__ + "static/scopriabitareco_valori_4_futuro-6f726a03771d7c105495b0efe476415d.jpg";